import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryServicePage,
  buildIndustryServiceHead,
} from "@/components/IndustryServicePage";
import { getIndustryServiceCombo } from "@/lib/industryServiceData";

const combo = getIndustryServiceCombo("local-seo", "hvac")!;

export const Route = createFileRoute("/local-seo-for-hvac")({
  head: () => buildIndustryServiceHead(combo),
  component: () => <IndustryServicePage combo={combo} />,
});
